import { connect } from 'react-redux';
import CareGuideAdminEditScreen from '../components/CareGuideAdminEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.careGuidesAdmin.get('isLoading'),
    success: state.careGuidesAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const CareGuideAdminEditScreenContainer = connect(mapStateToProps)(
  CareGuideAdminEditScreen
);

export default CareGuideAdminEditScreenContainer;
